import List from "@/components/list";
import vue from "@/main";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  function handleResult({ row }) {
    vue.$emit("scanResult", row.uuid, row.title);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-result-detail", "调查结果", () => handleResult(vo)]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Must = ({ props: { vo } }) => {
    return <div>{vo.row.isMust ? "是" : "否"}</div>
  }

  const AccountTableConfig = [
    {
      label: "题干",
      prop: "title",
      minWidth: "160"
    },
    {
      label: "是否必答",
      prop: "isMustName",
      minWidth: "120",
      render: vo => <Must vo={vo} />
    },
    {
      label: "参与人数",
      prop: "participants",
      minWidth: "120",
      showOverflowTooltip: true
    },

    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
